import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouterV6 } from '../../../helpers/withRouterV6.jsx';
import { Translate, I18n } from 'react-redux-i18n';

import { bindActionCreators } from 'redux';

import styles from './eyesOnly.module.css';
import * as accountSettingsActions from './reducer';
import * as templateBuilderActions from '../../../modules/template-builder-ex';
import * as templateHelper from '../../../components/template/templateHelper';
import get from 'lodash.get';
import { Record } from '../../../modules/bin/utility';
import { autocompleteOuterClear } from '../../../modules/autocomplete';

import { Button, Card, Form, Message } from 'semantic-ui-react';
import { TemplateAutocomplete } from '../../../components/template/templateAutocomplete';
import { TemplateDropdown } from '../../../components/template/templateDropdown';
import RecordResultMessage from '../../../components/common/recordResult';
import { TemplateHeader } from '../../../components/template/templateHeader';
import { TemplateOptions } from '../../../components/template/templateOptions';
import ConfirmationModal from '../../../components/common/confirmationModal';
import { formatDateByCountry } from '../../../helpers/dateAndTimeHelper';
import {
  getEntityOption,
  getOrganizationOption
} from '../../../helpers/entityOptionHelper';
import { formatTimeElapsedOrDate } from '../../../utils/time/formatTimeElapsed';
import MembershipItem, { getContextTypeLabel, getRoleLabel } from '../../../components/common/MembershipItem/MembershipItem';
import MfaReset from './mfaReset';
import PasskeysSupport from './passkeysSupport';

import { i18nKeys, paths } from '../constants';
import { 
  getRoleLevelOptions, 
  AdminContextType,
  getAvailableContextTypes,
  arePromotionsAvailable
} from '../../../constants/roles';
import {
  isSystemOwner as checkIsSystemOwner,
  AdminContextTypeApi,
  AdminRoleLevel,
  logOut
} from '../../../modules/session';
import { grecaptcha } from '../../../helpers/grecaptcha';

export class EyesOnly extends Component {
  state = {
    demoteModalOpen: false,
    demoteAllModalOpen: false,
    selectedMembershipId: null
  };

  // Use shared helpers from MembershipItem
  getContextTypeLabel = getContextTypeLabel;
  getRoleLabel = getRoleLabel;

  // Request helpers for autocomplete
  getOrganizationRequest = () => ({
    page: 1,
    pageSize: 75,
    resultType: 'Full',
    orderBy: { key: 'name', direction: 'asc' },
    filters: []
  });

  getCampaignRequest = () => ({
    page: 1,
    pageSize: 75,
    resultType: 'Full',
    orderBy: { key: 'name', direction: 'asc' },
    filters: [{ key: 'status', operator: 'EqualTo', value: 1 }],
  });

  getEventRequest = () => ({
    page: 1,
    pageSize: 75,
    resultType: 'Full',
    orderBy: { key: 'name', direction: 'asc' },
    filters: [{ key: 'status', operator: 'EqualTo', value: 1 }],
  });

  getEventOrganizerRequest = () => ({
    page: 1,
    pageSize: 75,
    resultType: 'Full',
    orderBy: { key: 'name', direction: 'asc' },
    filters: []
  });

  getCampaignOrganizerRequest = () => ({
    page: 1,
    pageSize: 75,
    resultType: 'Full',
    orderBy: { key: 'name', direction: 'asc' },
    filters: []
  });

  // Item formatters for autocomplete
  getOrganizationItem = (item) => getOrganizationOption(item);

  getCampaignItem = (item) =>
    getEntityOption(item, {
      text: accountSettingsActions.getCampaignDisplayName(item)
    });

  getEventItem = (item) => getEntityOption(item);

  getEventOrganizerItem = (item) => getEntityOption(item);

  getCampaignOrganizerItem = (item) => getEntityOption(item);

  // Change handlers for autocomplete
  handleOrganizationChange = (path, value, item) => {
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_ORGANIZATION, item);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_ORGANIZATION_ID, value);
  };

  handleCampaignChange = (path, value, item) => {
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_CAMPAIGN, item);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_CAMPAIGN_ID, value);
  };

  handleEventChange = (path, value, item) => {
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_EVENT, item);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_EVENT_ID, value);
  };

  handleEventOrganizerChange = (path, value, item) => {
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_EVENT_ORGANIZER, item);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_EVENT_ORGANIZER_ID, value);
  };

  handleCampaignOrganizerChange = (path, value, item) => {
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_CAMPAIGN_ORGANIZER, item);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_CAMPAIGN_ORGANIZER_ID, value);
  };

  // Context type change handler
  onContextTypeChange = (path, value) => {
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_CONTEXT_TYPE, value);
    // Clear any previously selected entity when context type changes
    this.clearAllAutocompletes();
  };

  // Admin role change handler
  onAdminRoleChange = (path, value) => {
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_ROLE_LEVEL, value);
  };

  onPromoteButtonClick = () => {
    if (this.props.contextType === AdminContextType.System) {
      this.setState({ systemPromotionModalOpen: true });
      return;
    }
    this.handlePromoteClick();
  };

  handleSystemPromotionClose = () => {
    this.setState({ systemPromotionModalOpen: false });
  };

  handleSystemPromotionConfirm = () => {
    this.setState({ systemPromotionModalOpen: false });
    this.handlePromoteClick();
  };

  // Promotion handler - uses contextType and role directly
  handlePromoteClick = () => {
    const { contextType, adminRole, organizationId, campaignId, eventId, eventOrganizerId, campaignOrganizerId } = this.props;
    
    const data = {
      contextType: contextType,
      role: adminRole || 'Admin'
    };

    // Add the appropriate ID array based on context type
    if (contextType === AdminContextType.Organization && organizationId) {
      data.organizationId = [organizationId];
    } else if (contextType === AdminContextType.Campaign && campaignId) {
      data.campaignId = [campaignId];
    } else if (contextType === AdminContextType.Event && eventId) {
      data.eventId = [eventId];
    } else if (contextType === AdminContextType.EventOrganizer && eventOrganizerId) {
      data.eventOrganizerId = [eventOrganizerId];
    } else if (contextType === AdminContextType.CampaignOrganizer && campaignOrganizerId) {
      data.campaignOrganizerId = [campaignOrganizerId];
    }

    this.props.accountSettingsActions.promoteAdmin(this.props.accountDetail.id, data);
  };

  // Demote all handler
  handleDemoteAllClick = () => {
    this.setState({ demoteAllModalOpen: true });
  };

  handleDemoteAllConfirm = () => {
    this.props.accountSettingsActions.demoteAdmin(this.props.accountDetail.id);
    this.setState({ demoteAllModalOpen: false });
  };

  handleDemoteAllClose = () => {
    this.setState({ demoteAllModalOpen: false });
  };

  // Demote single membership handler
  handleDemoteSingleClick = (membershipId) => {
    this.setState({ demoteModalOpen: true, selectedMembershipId: membershipId });
  };

  handleDemoteSingleConfirm = () => {
    this.props.accountSettingsActions.demoteSingleMembership(
      this.props.accountDetail.id,
      this.state.selectedMembershipId
    );
    this.setState({ demoteModalOpen: false, selectedMembershipId: null });
  };

  handleDemoteSingleClose = () => {
    this.setState({ demoteModalOpen: false, selectedMembershipId: null });
  };

  // Success handlers - reload account
  handlePromoteSuccess = () => {
    this.props.accountSettingsActions.clearRecord('promoteRecord');
    this.props.accountSettingsActions.getRecord(this.props.accountDetail.id);
    // Clear autocomplete selections
    this.clearAllAutocompletes();
  };

  handleDemoteSuccess = () => {
    this.props.accountSettingsActions.clearRecord('demoteRecord');
    this.props.accountSettingsActions.getRecord(this.props.accountDetail.id);
  };

  handleDemoteSingleSuccess = () => {
    this.props.accountSettingsActions.clearRecord('demoteSingleRecord');
    this.props.accountSettingsActions.getRecord(this.props.accountDetail.id);
  };

  clearAllAutocompletes = () => {
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_ORGANIZATION, null);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_ORGANIZATION_ID, null);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_CAMPAIGN, null);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_CAMPAIGN_ID, null);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_EVENT, null);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_EVENT_ID, null);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_EVENT_ORGANIZER, null);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_EVENT_ORGANIZER_ID, null);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_CAMPAIGN_ORGANIZER, null);
    this.props.templateBuilderActions.setResultValue(paths.PROMOTE_ADMIN_CAMPAIGN_ORGANIZER_ID, null);
  };

  isPromoteBtnLoading = () => Record.isRecordLoading(this.props.promoteRecord);
  isDemoteBtnLoading = () => Record.isRecordLoading(this.props.demoteRecord);
  isDemoteSingleBtnLoading = () => Record.isRecordLoading(this.props.demoteSingleRecord);

  // Check if promote button should be disabled
  isPromoteButtonDisabled = () => {
    const { contextType, organizationId, campaignId, eventId, eventOrganizerId, campaignOrganizerId, isOrgAdmin } = this.props;
    
    if (!contextType) return true;
    
    // For System, no entity selection needed - just enable the button
    if (contextType === AdminContextType.System) {
      return false;
    }
    
    // For Organization, can only have one - check if already org admin
    if (contextType === AdminContextType.Organization) {
      if (isOrgAdmin) return true;
      return !organizationId;
    }
    
    // For other context types, check if entity is selected
    if (contextType === AdminContextType.Campaign) return !campaignId;
    if (contextType === AdminContextType.Event) return !eventId;
    if (contextType === AdminContextType.EventOrganizer) return !eventOrganizerId;
    if (contextType === AdminContextType.CampaignOrganizer) return !campaignOrganizerId;
    
    return true;
  };

  // Render a single admin membership item using the shared component
  renderMembershipItem = (membership) => {
    return (
      <MembershipItem
        key={membership.id}
        membership={membership}
        onDemote={this.handleDemoteSingleClick}
        isDemoteLoading={this.isDemoteSingleBtnLoading() && this.state.selectedMembershipId === membership.id}
        isCurrentUserSystemOwner={this.props.isSystemOwner}
      />
    );
  };

  // Render the admin memberships list
  renderMembershipsList = () => {
    const memberships = this.props.adminMemberships || [];
    const { isSystemOwner } = this.props;

    // A membership is demotable if it's non-system, OR if it's system and the
    // current user is a system owner and the membership isn't owner-level
    const hasDemotableMemberships = memberships.some(m => {
      const isSystem = m.contextType === AdminContextTypeApi.System;
      if (!isSystem) return true;
      return isSystemOwner && m.role !== AdminRoleLevel.Owner;
    });

    if (memberships.length === 0) {
      return (
        <div className={styles.section}>
          <Message info>
            <Message.Content>{I18n.t(i18nKeys.ADMIN_MEMBERSHIPS_EMPTY)}</Message.Content>
          </Message>
        </div>
      );
    }

    return (
      <div className={styles.section}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <TemplateHeader as="h3" label={i18nKeys.ADMIN_MEMBERSHIPS_HEADER} />
          {hasDemotableMemberships && (
            <Button
              primary
              loading={this.isDemoteBtnLoading()}
              onClick={this.handleDemoteAllClick}
            >
              {I18n.t(i18nKeys.DEMOTE_ALL_BUTTON)}
            </Button>
          )}
        </div>

        <div>
          {memberships.map(this.renderMembershipItem)}
        </div>
      </div>
    );
  };

  // Render the promotion form
  renderPromotionForm = () => {
    const { contextType, adminMemberships, isSystemOwner } = this.props;
    
    // Check if any promotions are available based on existing memberships
    if (!arePromotionsAvailable(adminMemberships, isSystemOwner)) {
      return null;
    }

    // Get available context type options based on existing memberships
    const availableContextTypes = getAvailableContextTypes(adminMemberships, isSystemOwner);

    return (
      <div className={`promotion-form ${styles.spacedSection}`}>
        <div className="template-heading">
          <TemplateHeader as="h3" label={i18nKeys.PROMOTE_AND_DEMOTE_HEADER} />
        </div>
        <Form>
          <div className="promotion-container">
            <TemplateDropdown
              id={paths.PROMOTE_CONTEXT_TYPE}
              className="promote-organization"
              path={paths.PROMOTE_CONTEXT_TYPE}
              label={i18nKeys.CONTEXT_TYPE_LABEL}
              onChange={this.onContextTypeChange}
              options={availableContextTypes}
            />
          </div>
            
          <div className="promotion-container">
            <TemplateDropdown
              id={paths.PROMOTE_ADMIN_ROLE_LEVEL}
              className="promote-organization"
              path={paths.PROMOTE_ADMIN_ROLE_LEVEL}
              label={i18nKeys.PROMOTE_ADMIN_ROLE_LABEL}
              onChange={this.onAdminRoleChange}
              options={getRoleLevelOptions(contextType)}
            />
          </div>

          {/* Organization autocomplete */}
          {contextType === AdminContextType.Organization && (
            <div className="promotion-container">
              <TemplateAutocomplete
                key="promote-organization-admin"
                disabled={this.props.isOrgAdmin}
                className="promote-organization"
                entity="organization"
                label={i18nKeys.PROMOTE_ADMIN_ORGANIZATION_TITLE}
                placeholder={i18nKeys.PROMOTE_ADMIN_ORGANIZATION_PLACEHOLDER}
                path={paths.PROMOTE_ADMIN_ORGANIZATION_ID}
                selected="organization"
                onChange={this.handleOrganizationChange}
                request={this.getOrganizationRequest}
                getItem={this.getOrganizationItem}
                searchOnLoad={false}
              />
            </div>
          )}

          {/* Campaign autocomplete */}
          {contextType === AdminContextType.Campaign && (
            <div className="promotion-container">
              <TemplateAutocomplete
                key="promote-campaign-admin"
                className="promote-organization"
                entity="page/campaign"
                label={i18nKeys.PROMOTE_ADMIN_LINKED_CAMPAIGN_TITLE}
                placeholder={i18nKeys.PROMOTE_ADMIN_LINKED_CAMPAIGN_PLACEHOLDER}
                path={paths.PROMOTE_ADMIN_CAMPAIGN_ID}
                selected="campaign"
                onChange={this.handleCampaignChange}
                request={this.getCampaignRequest}
                getItem={this.getCampaignItem}
                searchOnLoad={false}
              />
            </div>
          )}

          {/* Event autocomplete */}
          {contextType === AdminContextType.Event && (
            <div className="promotion-container">
              <TemplateAutocomplete
                key="promote-event-admin"
                className="promote-organization"
                entity="page/event"
                label={i18nKeys.PROMOTE_ADMIN_LINKED_EVENT_TITLE}
                placeholder={i18nKeys.PROMOTE_ADMIN_LINKED_EVENT_PLACEHOLDER}
                path={paths.PROMOTE_ADMIN_EVENT_ID}
                selected="event"
                onChange={this.handleEventChange}
                request={this.getEventRequest}
                getItem={this.getEventItem}
                searchOnLoad={false}
              />
            </div>
          )}

          {/* Event Organizer autocomplete */}
          {contextType === AdminContextType.EventOrganizer && (
            <div className="promotion-container">
              <TemplateAutocomplete
                key="promote-event-organizer-admin"
                className="promote-organization"
                entity="EventOrganizer"
                label={i18nKeys.PROMOTE_ADMIN_LINKED_EVENT_ORGANIZER_TITLE}
                placeholder={i18nKeys.PROMOTE_ADMIN_LINKED_EVENT_ORGANIZER_PLACEHOLDER}
                path={paths.PROMOTE_ADMIN_EVENT_ORGANIZER_ID}
                selected="eventOrganizer"
                onChange={this.handleEventOrganizerChange}
                request={this.getEventOrganizerRequest}
                getItem={this.getEventOrganizerItem}
                searchOnLoad={false}
              />
            </div>
          )}

          {/* Campaign Organizer autocomplete */}
          {contextType === AdminContextType.CampaignOrganizer && (
            <div className="promotion-container">
              <TemplateAutocomplete
                key="promote-campaign-organizer-admin"
                className="promote-organization"
                entity="CampaignOrganizer"
                label={i18nKeys.PROMOTE_ADMIN_LINKED_CAMPAIGN_ORGANIZER_TITLE}
                placeholder={i18nKeys.PROMOTE_ADMIN_LINKED_CAMPAIGN_ORGANIZER_PLACEHOLDER}
                path={paths.PROMOTE_ADMIN_CAMPAIGN_ORGANIZER_ID}
                selected="campaignOrganizer"
                onChange={this.handleCampaignOrganizerChange}
                request={this.getCampaignOrganizerRequest}
                getItem={this.getCampaignOrganizerItem}
                searchOnLoad={false}
              />
            </div>
          )}

          {contextType === AdminContextType.System && (
            <Message warning>
              <Message.Content>
                {I18n.t('account.eyes-only.promoteAndDemote.system-warning')}
              </Message.Content>
            </Message>
          )}

          <div className="promotion-container">
            <Form.Field className="promote-btn">
              <Button
                primary
                loading={this.isPromoteBtnLoading()}
                disabled={this.isPromoteButtonDisabled()}
                onClick={this.onPromoteButtonClick}
              >
                <Translate value={i18nKeys.PROMOTE} />
              </Button>
            </Form.Field>
          </div>
        </Form>
      </div>
    );
  };

  /**
   * Forcing a rotation on another account. Not restricted to promotion: suspected credential
   * compromise is the other reason to want one, and the target is confined on their very next
   * request rather than at their next login.
   */
  isOwnAccount() {
    // Compared as strings: the session and the loaded account do not agree on type.
    return (
      this.props.currentUserId != null &&
      this.props.accountDetail?.id != null &&
      this.props.currentUserId.toString() ===
        this.props.accountDetail.id.toString()
    );
  }

  /**
   * Forcing a rotation on your own account ends your own sessions, so by the time the response
   * arrives the session in this tab is already dead: the wall can never appear and the next call
   * 401s into a login modal. Going to login deliberately says what actually happened, rather than
   * leaving a success banner sitting over a session that no longer exists.
   */
  componentDidUpdate(prevProps) {
    const justForced =
      Record.isSuccess(this.props.forcePasswordResetRecord) &&
      !Record.isSuccess(prevProps.forcePasswordResetRecord);

    if (justForced && this.isOwnAccount()) {
      grecaptcha(this.props.logOut, 'SessionOperation');
      this.props.history.push('/login');
    }
  }

  renderCredentialActions() {
    const isOwnAccount = this.isOwnAccount();
    const resetRequiredAt = this.props.accountDetail?.passwordResetRequiredAt;

    return (
      <div className={`promotion-form ${styles.spacedSection}`}>
        <div className="template-heading">
          <TemplateHeader as="h3" label="account.force-reset-action.label" />
        </div>
        {/* Already outstanding is the more useful thing to say: forcing another one achieves
            nothing the target can act on, and the elapsed time is what tells an administrator
            whether the person is stuck or simply has not got round to it yet. */}
        {resetRequiredAt ? (
          <Message warning size="small">
            <Message.Content>
              {I18n.t(
                isOwnAccount
                  ? 'account.force-reset-action.already-outstanding-self'
                  : 'account.force-reset-action.already-outstanding',
                {
                  elapsed: formatTimeElapsedOrDate(resetRequiredAt, undefined, {
                    relativeTimeOptions: { isUtc: true, inSentence: true }
                  })
                }
              )}
            </Message.Content>
          </Message>
        ) : (
          isOwnAccount && (
            <Message warning size="small">
              <Message.Content>
                {I18n.t('account.force-reset-action.self-warning')}
              </Message.Content>
            </Message>
          )
        )}
        <Button
          loading={Record.isRecordLoading(this.props.forcePasswordResetRecord)}
          onClick={this.handleForceResetClick}
        >
          <Translate value="account.force-reset-action.button" />
        </Button>
        {/* A plain Message rather than RecordResultMessage: that component is
            position:absolute;top:0 with a z-index, so it pins itself over the top of the card
            wherever it appears in the JSX and lands on top of the heading above. */}
        {Record.isSuccess(this.props.forcePasswordResetRecord) && (
          <Message
            positive
            size="small"
            onDismiss={
              this.props.accountSettingsActions.clearForcePasswordResetRecord
            }
          >
            <Message.Content>
              {I18n.t('account.force-reset-action.success')}
            </Message.Content>
          </Message>
        )}
        {Record.isError(this.props.forcePasswordResetRecord) && (
          <Message
            negative
            size="small"
            onDismiss={
              this.props.accountSettingsActions.clearForcePasswordResetRecord
            }
          >
            <Message.Content>
              {I18n.t('general.general-error-message')}
            </Message.Content>
          </Message>
        )}
      </div>
    );
  }

  handleForceResetClick = () => {
    this.setState({ forceResetModalOpen: true });
  };

  handleForceResetClose = () => {
    this.setState({ forceResetModalOpen: false });
  };

  handleForceResetConfirm = () => {
    this.setState({ forceResetModalOpen: false });
    this.props.accountSettingsActions.forcePasswordReset(
      this.props.accountDetail.id
    );
  };

  render() {
    // Handle success states
    if (Record.isSuccess(this.props.promoteRecord)) {
      this.handlePromoteSuccess();
    }
    if (Record.isSuccess(this.props.demoteRecord)) {
      this.handleDemoteSuccess();
    }
    if (Record.isSuccess(this.props.demoteSingleRecord)) {
      this.handleDemoteSingleSuccess();
    }

    // Initialize template model
    if (!this.props.isTemplateInited) {
      const model = new TemplateOptions().setModel(this.props.accountDetail);
      this.props.templateBuilderActions.setTemplateModel(model.getWithRule());
    }

    return (
      <div>
        <RecordResultMessage
          record={this.props.promoteRecord}
          onDismiss={this.props.accountSettingsActions.clearPromoteRecord}
        />
        <RecordResultMessage
          record={this.props.demoteRecord}
          onDismiss={this.props.accountSettingsActions.clearDemoteRecord}
        />
        <RecordResultMessage
          record={this.props.demoteSingleRecord}
          onDismiss={this.props.accountSettingsActions.clearDemoteSingleRecord}
        />

        <div className="general-conatiner">
          <Card fluid style={{ backgroundColor: 'rgba(216, 216, 216, 0.1)' }}>
            <div className="detail-container">
              <Card.Content>
                {this.renderMembershipsList()}
                {this.renderPromotionForm()}
                <MfaReset />
                <PasskeysSupport accountId={this.props.accountDetail?.id} />
                {this.renderCredentialActions()}
                <div className="bottom-space"></div>
              </Card.Content>
            </div>
          </Card>

          <Button floated="right" onClick={this.props.onCancel}>
            <Translate value={i18nKeys.CANCEL} />
          </Button>
        </div>

        {/* Confirmation modal for single demote */}
        <ConfirmationModal
          open={this.state.forceResetModalOpen}
          title={I18n.t('account.force-reset-action.confirm-title')}
          content={
            this.isOwnAccount()
              ? I18n.t('account.force-reset-action.confirm-message-self')
              : I18n.t('account.force-reset-action.confirm-message', {
                  email: this.props.accountDetail?.email
                })
          }
          onClose={this.handleForceResetClose}
          onSubmit={this.handleForceResetConfirm}
        />

        <ConfirmationModal
          open={this.state.systemPromotionModalOpen}
          title={I18n.t('account.eyes-only.promoteAndDemote.system-confirm-title')}
          content={I18n.t(
            'account.eyes-only.promoteAndDemote.system-confirm-message'
          )}
          onClose={this.handleSystemPromotionClose}
          onSubmit={this.handleSystemPromotionConfirm}
        />

        <ConfirmationModal
          open={this.state.demoteModalOpen}
          title={I18n.t(i18nKeys.DEMOTE_CONFIRM_TITLE)}
          content={I18n.t(i18nKeys.DEMOTE_CONFIRM_MESSAGE)}
          onClose={this.handleDemoteSingleClose}
          onSubmit={this.handleDemoteSingleConfirm}
        />

        {/* Confirmation modal for demote all */}
        <ConfirmationModal
          open={this.state.demoteAllModalOpen}
          title={I18n.t(i18nKeys.DEMOTE_CONFIRM_TITLE)}
          content={I18n.t(i18nKeys.DEMOTE_ALL_CONFIRM_MESSAGE)}
          onClose={this.handleDemoteAllClose}
          onSubmit={this.handleDemoteAllConfirm}
        />
      </div>
    );
  }
}

const mapState = ({ accountSettings, templateBuilderEx, session }) => {
  const account = accountSettings.record.data.data;
  return {
    accountDetail: account,

    isSysAdmin: account.isSysAdmin,
    isOrgAdmin: account.isOrgAdmin,
    isCampaignAdmin: account.isCampaignAdmin,
    isEventAdmin: account.isEventAdmin,
    isEventOrganizerAdmin: account.isEventOrganizerAdmin,
    isCampaignOrganizerAdmin: account.isCampaignOrganizerAdmin,

    // Current user's system owner status (uses shared session helper)
    isSystemOwner: checkIsSystemOwner(session),

    // Admin memberships from API
    adminMemberships: account.adminMemberships || [],

    isTemplateInited: templateBuilderEx.inited,
    promoteRecord: accountSettings.promoteRecord,
    demoteRecord: accountSettings.demoteRecord,
    demoteSingleRecord: accountSettings.demoteSingleRecord,
    forcePasswordResetRecord: accountSettings.forcePasswordResetRecord,
    currentUserId: get(session, 'account.id'),

    // Selected values from autocomplete
    organizationId: templateHelper.getValue(templateBuilderEx, paths.PROMOTE_ADMIN_ORGANIZATION_ID),
    campaignId: templateHelper.getValue(templateBuilderEx, paths.PROMOTE_ADMIN_CAMPAIGN_ID),
    eventId: templateHelper.getValue(templateBuilderEx, paths.PROMOTE_ADMIN_EVENT_ID),
    eventOrganizerId: templateHelper.getValue(templateBuilderEx, paths.PROMOTE_ADMIN_EVENT_ORGANIZER_ID),
    campaignOrganizerId: templateHelper.getValue(templateBuilderEx, paths.PROMOTE_ADMIN_CAMPAIGN_ORGANIZER_ID),
    
    // Promotion form values
    contextType: templateHelper.getValue(templateBuilderEx, paths.PROMOTE_CONTEXT_TYPE),
    adminRole: templateHelper.getValue(templateBuilderEx, paths.PROMOTE_ADMIN_ROLE_LEVEL)
  };
};

const mapDispatch = (dispatch) => {
  return {
    accountSettingsActions: bindActionCreators(accountSettingsActions, dispatch),
    templateBuilderActions: bindActionCreators(templateBuilderActions, dispatch),
    logOut(verificationToken = null) {
      dispatch(logOut(verificationToken));
    },
    clearAutocomplete(path) {
      dispatch(autocompleteOuterClear(path));
    }
  };
};

export default withRouterV6(connect(mapState, mapDispatch)(EyesOnly));
